import { Link } from "@tanstack/react-router";
import { Button } from "../ui/button";
import { useLocation } from "@tanstack/react-router";
import { cn } from "@/lib/utils";
function ActiveIndicator({ size = "default" }: { size?: "sm" | "default" }) {
  return (
    <div
      className={cn(
        "bg-primary absolute h-1 w-3 -translate-x-1/2 transform rounded-full",
        size === "sm"
          ? "bottom-0 left-1/2"
          : "-bottom-1 left-[calc(50%+0.625rem)]",
      )}
    />
  );
}
export function NavLink({
  href,
  children,
  size = "default",
}: {
  href: string;
  children: React.ReactNode;
  size?: "sm" | "default";
}) {
  const location = useLocation();
  const isActive = location.pathname.startsWith(href);
  return (
    <div className="relative flex items-center justify-center">
      <Button
        variant="ghost"
        className={cn(
          "text-muted-foreground",
          isActive && "text-foreground",
          size === "sm"
            ? "h-auto min-h-12 px-2 py-1 text-[11px] leading-tight [&_svg]:size-4"
            : "text-sm",
        )}
        render={<Link to={href} aria-current={isActive} />}
      >
        {children}
      </Button>
      {isActive && <ActiveIndicator size={size} />}
    </div>
  );
}
